module.exports = __webpack_public_path__ + "img/logo.13952da0.png";